import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '../static/flexible.js';
import "mint-ui/lib/style.css";

import MintUI from "mint-ui";
import { Toast } from "mint-ui";

// 全局引用并使用轮播图组件
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
// Vue.use(ElementUI);
Vue.use(MintUI);

Vue.prototype.$toast = Toast;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
